import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Price chip overlaid on a card image. Must be rendered inside `.card-img-top` so it sits on
// top of the picture without taking part in the hover zoom (see card.scss `.card-price`).
// With `originalPrice` the chip becomes a sale chip: the discounted price (children) leads and
// the struck-through original follows it as the anchor.
const PriceBadge = (props) => {
  const isSale = props.originalPrice != null;

  const className = classNames({
    'card-price': true,
    'card-price-muted': props.muted,
    'card-price-sale': isSale,
  });

  const current = (
    <>
      {props.prefix && <span className="card-price-prefix">{props.prefix}</span>}
      {props.children}
    </>
  );

  if (!isSale) {
    return <span className={className}>{current}</span>;
  }

  // Screen readers skip strikethrough, so the label says what changed.
  const label = `${props.prefix ? `${props.prefix} ` : ''}${props.children} with coupon, was ${props.originalPrice}`;

  return (
    <span className={className} role="img" aria-label={label}>
      <span className="card-price-current" aria-hidden="true">
        {current}
      </span>
      <s className="card-price-original" aria-hidden="true">
        {props.originalPrice}
      </s>
    </span>
  );
};

PriceBadge.propTypes = {
  prefix: PropTypes.string,
  muted: PropTypes.bool,
  // Formatted price the sale replaces; turns the chip into the sale variant.
  originalPrice: PropTypes.string,
  children: PropTypes.node,
};

PriceBadge.defaultProps = {
  muted: false,
};

export default PriceBadge;
